<script>
import GlobalAppSidebar from '@/components/GlobalAppSidebar'
import UiLayer from '@/components/UiLayer'

export default {
  name: 'App',
  components: {
    GlobalAppSidebar,
    UiLayer
  },
  created() {
    const app = document.getElementById('app')
    app.addEventListener('mousedown', (e) => {
      // click-'outside'
      const outside = (
        e.target && (
          e.target.id === 'app' ||
          e.target.classList.contains('container-editor') ||
          e.target.classList.contains('tools-panel') ||
          e.target.classList.contains('editor-tracks')
        )
      )
      if (outside) {
        this.$$debug('click outside', e.target.classList)
        this.$store.dispatch('ui/clickOutside')
        this.$store.commit('project/dnd', null)
        this.$store.dispatch('project/activeTrack', null)
      }
    })

    const isExternalFileDrag = (e) => {
      const dt = e && e.dataTransfer
      if (!dt) return false
      const types = dt.types ? Array.from(dt.types) : []
      if (types.includes('Files')) return true
      if (dt.items && Array.from(dt.items).some(it => it && it.kind === 'file')) return true
      return false
    }

    let dragDepth = 0

    window.addEventListener('dragenter', (e) => {
      if (!isExternalFileDrag(e)) return
      e.preventDefault()
      e.stopPropagation()
      dragDepth += 1
      this.$store.commit('ui/fileDrop', { active: true, count: dragDepth })
    })

    const onDragOver = (e) => {
      if (!isExternalFileDrag(e)) return
      e.preventDefault()
      e.stopPropagation()
      if (e.dataTransfer && 'dropEffect' in e.dataTransfer)
        e.dataTransfer.dropEffect = 'copy'
      this.$store.commit('ui/fileDrop', { active: true, count: dragDepth })
    }
    window.addEventListener('dragover', onDragOver, { passive: false })
    document.addEventListener('dragover', onDragOver, { passive: false })

    window.addEventListener('dragleave', (e) => {
      if (!isExternalFileDrag(e)) return
      e.preventDefault()
      e.stopPropagation()
      dragDepth = Math.max(0, dragDepth - 1)
      const stillActive = dragDepth > 0
      this.$store.commit('ui/fileDrop', { active: stillActive, count: dragDepth })
    })

    const onDrop = (e) => {
      if (!isExternalFileDrag(e)) return
      e.preventDefault()
      e.stopPropagation()
      // Add all dropped files to the Library (same flow as File button)
      const files = Array.from(e.dataTransfer.files || [])
      files.forEach((file) => {
        this.$store.dispatch('project/addMedia', {
          file,
          uploadNew: true,
          source: 'upload',
        })
      })
      // Optionally: ensure the library panel is visible
      // this.$store.dispatch('cmd/openPanel', { panel: 'library' })
      dragDepth = 0
      this.$store.commit('ui/fileDrop', { active: false, count: 0 })
    }
    window.addEventListener('drop', onDrop, { passive: false })
    document.addEventListener('drop', onDrop, { passive: false })
  },
  watch: {
    '$store.state.user.uid'(next, prev) {
      this.$$debug('watcher uid', next, this.$route)
      if (prev && !next) {
        // sign out
        this.$router.push({name:'sign-in'})
        return
      }
      if (!prev && next) {
        if (this.$store.state.user.redirectAfterLogin) {
          const next = this.$store.state.user.redirectAfterLogin
          this.$store.commit('user/redirectAfterLogin', null)
          this.$router.push(next)
          return
        }
        if (['beta', 'sign-in', 'sign-up'].includes(this.$route.name))
          this.$router.push({ name: 'projects' })
      }
    }
  }
}
</script>

<template>
  <UiLayer/>
  <GlobalAppSidebar/>
  <router-view/>
</template>
